<div class="footer container-fluid">
  <div class="row align-items-start gy-1">
    <div class="col-12 col-md-6 text-center text-md-left">
      goZmart Real Estate Platform - <strong>{{ version }}</strong>
    </div>
    <div class="col-12 col-md-6 text-center text-md-right">
      Copyright © 2017-21 goZmart Iberia. <strong>{{ 'allRights' | translate }}.</strong>
    </div>
  </div>
</div>